import Service from '../Service'
import {LandingV4InstanceV2 } from './Instance'

export class ReferidosService extends Service {
  constructor(tenant) {
    super()
    this._hostName = window ? `https://${window.location.host}` : 'localhost'
    this.setTenant(tenant)
    this._utm = {
      source: '',
      medium: '',
      campaign: '',
      term: '',
      content: ''
    }    
    this._sellerPartner=''
    this._sellerId=''
    this._branchId=''
    this._firstName=''
    this._lastName=''
    this._mobileNumber=''
    this._postalCode=''
    this._productId=''
    this._requestedAmount = 0
    this._tokenId=''
  }
  setBranchId(branchId) {
    this._branchId = branchId
  }
  setToken(tokenId) {
    this._tokenId = `${tokenId}`
  }
  setProductId(productId) {
    this._productId = `${productId}`
  }
  setFirstName(firstName) {
    this._firstName = `${firstName}`
  }
  setTenant(tenant) {
    this._tenant = `${tenant}`
  }
  setLastName(lastName) {
    this._lastName = `${lastName}`
  }
  setMobileNumber(mobileNumber){
    this._mobileNumber =  `${mobileNumber}` 
  }  
  setUtmSource(source) {
    this._utm = { ...this._utm, source: source }
  }
  setUtmMedium(medium) {
    this._utm = { ...this._utm, medium: medium }
  }
  setUtmCampaign(campaign) {
    this._utm = { ...this._utm, campaign: campaign }
  }
  setUtmTerm(term) {
    this._utm = { ...this._utm, term: term }
  }
  setUtmContent(content) {
    this._utm = { ...this._utm, content: content }
  }
  setPostalCode(postalCode) {
    this._postalCode = `${postalCode}`
  }
  setRequestedAmount(requestedAmount) {
    this._requestedAmount = requestedAmount
  }

  setBrowserId(fbp) {
    this._utm = { ...this._utm, browserId: fbp }
  }
  
  setSellerPartner(sellerPartner) {
    this._sellerPartner = sellerPartner
  }
  setSellerId(sellerId) {
    this._sellerId = sellerId
  }

  get data() {
    return {
      hostName: `${this._hostName}`,
      tenant: `${this._tenant}`,
      sellerPartner: `${this._sellerPartner}`,
      branchId:`${this._branchId}`,
      utm: { ...this._utm },
      productId: `${this._productId}`,
      firstName: `${this._firstName}`,    
      lastName: `${this._lastName}`,      
      mobileNumber: `${this._mobileNumber}`,
      postalCode: `${this._postalCode}`,
      requestedAmount: this._requestedAmount,
      terms:78,
      period:"SemiMonthly"
    }
  }

  /**
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  send() {
    const self = this
    return this._requestWrapper(LandingV4InstanceV2({
      method: 'POST',
      url: '/leads/named',
      headers: {
        Authorization: `Bearer ${this._tokenId}`,
      },
      data: self.data
    }))
  }

  token() {
    const self = this
    return this._requestWrapper(LandingV4InstanceV2({
      method: 'POST',
      url: '/oauth',
      data: {
              applicationId: "b5014631-26ad-4b57-98bf-19890b78cd35",
              secret: "FbT?gf!BmG!&bqsfSBEZM5ht"
            }
    }))
  }

}
